<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">我的论文</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'usInfor',
  data () {
    return {
    };
  },
  created () {
  },
  methods: {

  }
};
</script>

<style scoped>
</style>